/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

export function getFeature(key) {
  return defaultApiInstance.get(`v1/feature/${key}`);
}
